import { Component, ElementRef, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-example-monouse-component",
  template: ``,
  styles: [],
  standalone: false,
})
export class GoCompaniesComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    window.location.replace('/tech/'+this.fatherContaierRef.idElement+'/products')
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
